export const datesToTitle = (dates: string | undefined) => {
  if (dates === undefined) {
    return undefined;
  }
  const datesArray = dates.split(',');
  if (datesArray.length === 1) {
    const [year, month, day] = datesArray[0].split('-');
    return `${Number(year)}年${Number(month)}月${Number(day)}日`;
  } else {
    return '絞り込んだ日程';
  }
};
